import { useCallback } from 'react'
import { useSnackbar as useNotistackSnackbar, VariantType } from 'notistack';
import { Button } from '@material-ui/core';

const useSnackbar = () => {
    const { enqueueSnackbar, closeSnackbar } = useNotistackSnackbar();

    const action = useCallback((key: string | number) => (
        <>
            <Button variant='contained' size='small' onClick={() => { closeSnackbar(key) }}>
                OK
            </Button>
        </>
    ), [closeSnackbar]);

    const displayMessage = useCallback(
        (message: string, variant: VariantType) => {
            enqueueSnackbar(message, {
                variant,
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center',
                },
                preventDuplicate: true,
                autoHideDuration: 2500,
                action
            })
        },
        [enqueueSnackbar, action],
    )

    const displaySuccess = useCallback((message: string) => {
        displayMessage(message, 'success')
    }, [displayMessage]);
    const displayError = useCallback((message: string) => {
        displayMessage(message, 'error')
    }, [displayMessage]);
    const displayInfo = useCallback((message: string) => {
        displayMessage(message, 'info')
    }, [displayMessage]);
    const displayWarning = useCallback((message: string) => {
        displayMessage(message, 'warning')
    }, [displayMessage]);



    return { displayInfo, displayError, displayWarning, displaySuccess };
}

export default useSnackbar;
